/**
 * DEX Scroll Animation — IntersectionObserver-based reveal
 *
 * Elements with [data-dex-animate], [data-dex-animate-stagger], or [data-dex-stagger]
 * get the .dex-visible class added when they enter the viewport.
 * Works with the CSS transitions in dex-design.css and dex-page-sections.css.
 */

(function () {
  if (!('IntersectionObserver' in window)) {
    // Fallback: show everything immediately
    document.querySelectorAll('[data-dex-animate], [data-dex-animate-stagger], [data-dex-stagger]').forEach(function (el) {
      el.classList.add('dex-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dex-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  function observe() {
    document.querySelectorAll('[data-dex-animate], [data-dex-animate-stagger], [data-dex-stagger]').forEach(function (el) {
      if (!el.classList.contains('dex-visible')) {
        observer.observe(el);
      }
    });
  }

  // Observe on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-observe after Shopify section renders (theme editor, AJAX)
  document.addEventListener('shopify:section:load', observe);
})();
